import classNames from "classnames";
import React from "react";
import Link from "../Link/Link";
import Text from "../Text/Text";
import styles from "./MediaBlock.module.scss";

interface MediaProps {
  halfWidth?: boolean;
  to?: string;
  className?: string;
  mediaItem: JSX.Element | null;
  caption?: string;
  attribution?: string;
}

const Media = ({
  attribution,
  className,
  mediaItem,
  caption,
  halfWidth,
  to
}: MediaProps) => {
  if (!mediaItem) {
    return null;
  }
  const mediaItemWithClass = React.cloneElement(mediaItem, {
    className: classNames(styles.media, mediaItem.props.className)
  });

  const captioned =
    caption || attribution ? (
      <figure className={classNames(styles.figure, styles.outer)}>
        {mediaItemWithClass}
        <figcaption>
          {caption && (
            <Text variant="defaultTiny" as="p">
              {caption}
            </Text>
          )}
          {attribution && (
            <Text variant="defaultTiny" as="p">
              {attribution}
            </Text>
          )}
        </figcaption>
      </figure>
    ) : (
      mediaItemWithClass
    );

  const linked = to ? <Link to={to}>{captioned}</Link> : captioned;

  return React.cloneElement(linked, {
    className: classNames(
      className,
      styles.outer,
      halfWidth && styles.halfWidth,
      linked.props.className
    )
  });
};

export default Media;
